module.exports = __webpack_public_path__ + "media/images/icon-cash@3x-1c5697cb60bcdc3a64790722cc446b21.png";